import { create } from 'zustand';

export const useUploadStore = create((set, get) => ({
  setUploadById: (id, value) => set({ [id]: value }),
  getUploadById: id => get()[id],
}));
